import Layout from "@/components/common/Layout/Layout";

const TermsCondition = () => {
    return (
      <Layout pageTitle="Softex Solution | Terms and Condition">
        <div className="max-w-screen-xl my-6 mx-auto dark:text-white">
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Terms & Conditions of Softex Solution
            </h1>
            <p>
              Please read these Terms & Conditions carefully before using our
              website Softex Solution or Website. By accessing or using the
              Website, you agree to be bound by these Terms & Conditions. If you
              do not agree to all the terms and conditions of this agreement,
              then you may not access the Website or use any services.
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Use of Website
            </h1>
            <p>
              Softex Solution is an IT website designed to provide software
              solutions to businesses and individuals. The content and services
              provided on the Website are for informational and non-commercial
              purposes only
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              User Accounts
            </h1>
            <p>
              In order to access certain features of the Website, you may be
              required to register for an account. You must provide accurate and
              complete information when registering, and you are responsible for
              maintaining the confidentiality of your account credentials.
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Intellectual Property
            </h1>
            <p>
              All content and materials on the Website, including but not
              limited to text, graphics, logos, images, and software, are the
              property of Softex Solution or its licensors and are protected by
              intellectual property laws
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Disclaimer of Warranties
            </h1>
            <p>
              The Website is provided as is and without warranties of any kind,
              either express or implied, including but not limited to warranties
              of merchantability, fitness for a particular purpose, or
              non-infringement.
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Limitation of Liability
            </h1>
            <p>
              Softex Solution shall not be liable for any damages whatsoever
              arising out of or in connection with the use or inability to use
              the Website, including but not limited to direct, indirect,
              incidental, consequential, or punitive damages.
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Indemnification
            </h1>
            <p>
              You agree to indemnify and hold harmless Softex Solution and its
              officers, directors, employees, agents, and affiliates from any
              claims, damages, liabilities, and expenses including attorneys
              fees arising out of or in connection with your use of the Website
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Governing Law
            </h1>
            <p>
              These Terms & Conditions shall be governed by and construed in
              accordance with the laws of the State of California, without
              regard to its conflicts of law provisions.
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Modifications to Terms & Conditions
            </h1>
            <p>
              Softex Solution reserves the right to modify these Terms &
              Conditions at any time without notice. Your continued use of the
              Website after any such modifications shall constitute your
              acceptance of the modified terms.
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Termination
            </h1>
            <p>
              Softex Solution may terminate or suspend your access to the
              Website at any time, with or without cause, and without notice
            </p>
          </div>
          <div className="py-3">
            <h1 className="font-bold text-blue-600 text-xl py-3">
              Entire Agreement
            </h1>
            <p>
              These Terms & Conditions constitute the entire agreement between
              you and Softex Solution regarding the use of the Website,
              superseding any prior agreements between you and Softex Solution.
            </p>
          </div>
        </div>
      </Layout>
    );
};

export default TermsCondition;